import Vue from "vue";
import Router from "vue-router";
import Products from "./views/Products/Products";
Vue.use(Router);

//解决重复push路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      title:
        "HiMo Industry: Mold Manufacturer In China, Custom Moulding & 3D Printing Service Company",
      content: {
        keywords:
          "mould manufacturers,mould suppliers,mould maker,injection mold,molding companies,haier mold",
        description:
          "HiMo Industry is a world-leading mould provider specialized in manufacturing injection molds and providing injection molding services. Ideal for automotive, home appliances, electronic products, medical, aerospace, and millitary industry. Get Custom Quote Now!",
      },
    },
    component: (resolve) => require(["./views/Home/Home"], resolve),
  },
  {
    path: "/home/:anchor",
    name: "home",
    meta: {
      title: "HiMo Industry-The World's Largest Moulds Provider",
      content: {
        keywords:
          "custom molding,custom moulding, mold custom , made,manufacturing,HiMo Industry",
        description:
          "Hai-Industry The World's largest Visualized Mould Industry Ecological Chain Platform",
      },
    },
    component: (resolve) => require(["./views/Home/Home"], resolve),
    alias: "/home",
  },
  {
    path: "/about/:tab",
    name: "about",
    meta: {
      title: "About Us",
      content: {
        keywords:
          "custom molding,custom moulding, mold custom , made,manufacturing,HiMo Industry",
        description:
          "COSMOPlat is wholly owned by Haier Group which is a world-leading provider of solutions to better life. As the world’s first and only IoT ecosystem brand, Haier has been included on the list of BrandZ™ Top 100 Most Valuable Global Brands for two consecutive years. Haier offers services for over 1 billion families in 160 countries or regions around the world. ",
      },
    },
    component: (resolve) => require(["./views/AboutUs/AboutUs"], resolve),
  },
  {
    path: "/quotation",
    name: "quotation",
    meta: {
      title: "quotation",
      content: {
        keywords: "Mould , industry , mold custom , made,manufacturing",
        description: "Get Your Quotation",
      },
    },
    component: (resolve) => require(["@/views/Quotation/Quotation"], resolve),
  },
  {
    path: "/products-category/:category",
    name: "products",
    meta: {
      title: "Products",
      content: {
        keywords: "Mould , industry , mold custom , made,manufacturing",
        description:
          "Hai-Industry The World's largest Visualized Mould Industry Ecological Chain Platform",
      },
    },
    component: (resolve) => require(["@/views/Products/Products"], resolve),
  },
  {
    path: "/products-list/:category/:id",
    name: "products-list",
    component: (resolve) =>
      require(["@/views/ProductsList/ProductsList"], resolve),
  },
  {
    path: "/blog/:title/:id",
    name: "blog",
    component: (resolve) => require(["@/views/Blog/Blog"], resolve),
    props: true,
  },
  {
    path: "/search",
    name: "SearchManagement",
    meta: {
      title: "Search management",
      content: {
        keywords:
          "Products,Suppliers,Mould, Industry , Mold custom , made,manufacturing",
        description:
          "Hai-Industry The World's largest Visualized Mould Industry Ecological Chain Platform",
      },
    },
    component: (resolve) =>
      require(["@/views/SearchManagement/SearchManagement"], resolve),
  },
  {
    path: "/product-detail/:product/:id",
    name: "product-detail",
    component: (resolve) =>
      require(["@/views/ProductDetail/ProductDetail"], resolve),
  },
  {
    path: "/products-and-service",
    name: "products-and-service",
    content: {
      title: "HiMo Industry: Custom Mold Products & Moulding Service for Sale",
      keywords: "molding,3d printing,plastic mold,mould,plastic molds",
      description:
        "HiMo Industry provides injection molding products and service for years. We supply custom injection moulding products, 3d printing products, mould accessories, and die casting. Contact us to learn more about our mold and moulding service.",
    },
    component: (resolve) =>
      require(["@/views/ProductsAndService/ProductsAndService"], resolve),
  },
  {
    path: "/site-map",
    name: "siteMap",
    meta: {
      title: "Site Map",
    },
    component: (resolve) => require(["@/views/SiteMap/SiteMap"], resolve),
  },
  {
    path: "/equipment-supply",
    name: "equipmentSupply",
    meta: {
      title:
        "Injection Molding Equipment, Stamping Machine, EDM & WEDM CNC Machine for Sale | HiMo Industry",
      content: {
        keywords:
          "cnc machine,injection molding machine,molding machine,edm machine,stamping machine",
        description:
          "As a leading CNC equipment manufacturer in China, HiMo Industry offers a wide range of precision equipment supply for injection molding, stamping, and 3D printing service. Choose from the great selection of advanced equipment supply now.",
      },
    },
    component: (resolve) =>
      require(["@/views/EquipmentList/EquipmentList"], resolve),
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    meta: {
      title: "Site Map",
    },
    component: (resolve) =>
      require(["@/views/PrivacyPolicy/PrivacyPolicy"], resolve),
  },
  {
    path: "/suppliers/:supplier/:id",
    name: "suppliers",
    meta: {
      title: "Suppliers | HiMo Industry",
      content: {
        keywords: "Suppliers",
        description: "Suppliers",
      },
    },
    component: (resolve) => require(["@/views/Suppliers/Suppliers"], resolve),
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title:
        "Hai-Industry The World's largest Visualized Mould Industry Ecological Chain Platform",
    },
    component: (resolve) => require(["@/views/error/404"], resolve),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.content) {
    document
      .querySelector("meta[name='keywords']")
      .setAttribute("content", to.meta.content.keywords);
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", to.meta.content.description);
  }
  next();
});

export default router;
